export default __webpack_public_path__ + "static/media/logo-extensivo-programado-2023.404c2a64.svg";